import { Timesheet } from "@/types";
import { baseApi } from "../baseApi";

type TimesheetResponse = {
  user: {
    id: number;
    name: string;
  };
  timesheets: Timesheet[];
}[];

const timesheetsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTimesheets: builder.query<TimesheetResponse, { date?: string }>({
      query: ({ date }) => ({
        url: `mover/timesheets`,
        params: { date },
      }),
    }),

    addTimesheet: builder.mutation<
      Timesheet,
      {
        data: {
          on_date: string;
          user_id: number;
          notes: string;
          started_at: string;
          ended_at: string;
        };
      }
    >({
      query: ({ data }) => ({
        url: `mover/timesheets`,
        method: "POST",
        body: data,
      }),
    }),

    updateTimesheet: builder.mutation<
      Timesheet,
      {
        id: number;
        data: {
          started_at?: string;
          ended_at?: string;
          _destroy?: boolean;
        };
      }
    >({
      query: ({ id, data }) => ({
        url: `mover/timesheets/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),

    voidTimesheet: builder.mutation<Timesheet, { id: number }>({
      query: ({ id }) => ({
        url: `mover/timesheets/${id}/void`,
        method: "POST",
      }),
    }),

    approveAllTimesheets: builder.mutation<Timesheet[], { ids: number[] }>({
      query: ({ ids }) => ({
        url: `mover/timesheets/approve-all`,
        method: "POST",
        body: { ids },
      }),
    }),
  }),
});

export const {
  useGetTimesheetsQuery,
  useUpdateTimesheetMutation,
  useVoidTimesheetMutation,
  useAddTimesheetMutation,
  useApproveAllTimesheetsMutation,
} = timesheetsApi;
